// Centralized configuration for API endpoints and environment variables.
const trimTrailingSlashes = (value: string): string =>
  value.replace(/\/+$/, "");
const ensureLeadingSlash = (value: string): string =>
  `/${value.replace(/^\/+/, "")}`;
const requireConfig = (name: string, value: string | undefined): string => {
  if (!value) {
    throw new Error(`${name} must be defined`);
  }
  return value;
};

const API_ORIGIN = trimTrailingSlashes(
  requireConfig("VITE_API_ORIGIN", import.meta.env.VITE_API_ORIGIN),
);
const API_ADMIN_PATH = ensureLeadingSlash(
  requireConfig("VITE_API_ADMIN_BASE", import.meta.env.VITE_API_ADMIN_BASE),
);

// The only application-level source of truth for the complete API base URL.
export const API_BASE_URL = `${API_ORIGIN}${API_ADMIN_PATH}`;
// Public (non-admin) API, e.g. GET /regions/search for the promotion city picker.
export const API_PUBLIC_BASE_URL = `${API_ORIGIN}/api`;
export const APP_TITLE = import.meta.env.VITE_APP_TITLE || "TripNester Admin";
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || "1.0.0";

// Environment detection
export const ENV = import.meta.env.MODE || "development";
export const IS_DEVELOPMENT = ENV === "development";
export const IS_PRODUCTION = ENV === "production";
